
type TableAccordionDataCreatorType<T> = {
    pathToId: string;
    createHeaderCells: (item: T) => ({ id: number; content: React.ReactNode; className?: string }[]);
    createRowCells: (item: T) => ({ id: number; content: React.ReactNode; className?: string }[]);
};

export const getTableAccordionDataCreator = <T>({
    pathToId,
    createHeaderCells,
    createRowCells
}: TableAccordionDataCreatorType<T>) => (data: T[]) => ({
    accordionView: {
        rows: data.map(item => (
            {
                id: item[pathToId as keyof T],
                headerCells: createHeaderCells(item),
                rowCells: createRowCells(item)
            }
        ))
    }
});
